<template>
  <div class="assessmentSection questionsSection">
    <div class="questionsTopBG"></div>
    <div class="pageContent">
      <div class="pageTitle">First, we need to learn about your home.</div>
      <section class="assessmentContent">
        <question id="1" lead-key="buildingType" ref="buildingType">
          <div
            slot="learn-more"
          >Unlike single family home's, Condo's and Town Homes may have different vulnerabilities based on things like common walls, entryways, hallways and public areas which need to be considered to protect from everyday threats of burglary, intrusion, fire, and environmental risks.</div>
        </question>

        <transition name="fade">
          <div v-if="lead.buildingType">
            <question id="8" lead-key="homeSqft" ref="homeSqft">
              <div
                slot="learn-more"
              >You don't need to be exact however this helps determine the proper number of interior motions sensors needed if you are not protecting every window individually. It also helps us suggest the proper number of smoke communicators for fire protection.</div>
            </question>
          </div>
        </transition>

        <transition name="fade">
          <div v-if="lead.homeSqft">
            <question
              id="9"
              lead-key="homeFloors"
              :more-input="true"
              :more-value="3"
              ref="homeFloors"
            >
              <div
                slot="learn-more"
              >This will help determine the threats of entry for intrusion and the best placement for smoke communicators and Carbon Monoxide Communicators.</div>
            </question>
          </div>
        </transition>

        <transition name="fade">
          <div v-if="lead.homeFloors">
            <question id="10" lead-key="homeBasement" ref="homeBasement"></question>
          </div>
        </transition>

        <transition name="fade">
          <div v-if="lead.homeBasement == 'Yes'">
            <question id="18" lead-key="homeBasementFinished" ref="homeBasementFinished"></question>
          </div>
        </transition>

        <continue-button :before="mixpanelTracking" to="/assessment/communications" />
        <div class="startOverSection text-center">
          <a
            href="/assessment/start-over"
            onclick="mixpanel.track('startedOver')"
          >Clear data and start over</a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["lead"])
  },
  methods: {
    mixpanelTracking() {
      let data = {
        A_Building_buildingType: this.lead.buildingType,
        A_Building_squareft: this.lead.homeSqft,
        A_Building_numberOfFloors:
          this.lead.homeFloorsInput || this.lead.homeFloors,
        A_Building_hasBasement: this.lead.homeBasement == "Yes",
        A_Building_basementState: this.lead.homeBasementFinished
      };
      mixpanel.track("completedBuildingSection", data);
      mixpanel.people.set(data);
    }
  },
  mounted() {
    this.$Progress.set(28);
  }
};
</script>

<style lang="css">
</style>
